
<template>

<div class="form-ajax">
    <form v-on:submit="sendForm">
        <div class="row">
            <div class="col-md-12">
                        <h2>Добавить отзыв</h2>
                            <div class="form-content row" v-show="!responseOk">
                                <v-icon>mdi-home</v-icon>
                                <div class="one-group" :class="group.CLASS" v-for="group in dataBitrix">
                                    
                                        <div class="one-param" v-for="param in group.PARAMS">

                                            
                                                    <input type="text" v-if="param.PROPERTY_TYPE == 'S' && param.ROW_COUNT == '1'" v-model="param.VALUE_USER" :placeholder="param.NAME">

                                                    <label for="" v-if="param.CODE == 'RATING'"> Ваша оценка: </label>
                                                    <v-rating
                                                        v-if="param.CODE == 'RATING'"
                                                        v-model="param.VALUE_USER"
                                                        hover
                                                        length="5"
                                                        color="yellow darken-3"
                                                        background-color="grey darken-1"
                                                        >
                                                        
                                                    </v-rating>
                                                    <div class="radio-group" v-if="param.PROPERTY_TYPE == 'L' && param.LIST_TYPE == 'C'">
                                                        <div class="one-radio" v-for="list_one in param.LIST">
                                                            <input type="radio" :id="list_one.XML_ID" :value="list_one.ID" :name="param.CODE" v-model="param.VALUE_USER">
                                                            <label :for="list_one.XML_ID">{{list_one.VALUE}}</label>
                                                        </div>
                                                    </div>

                                                    <div class="select" v-if="param.PROPERTY_TYPE == 'L' && param.LIST_TYPE == 'L'">
                                                            <select  v-model="param.VALUE_USER">
                                                                    <option v-for="list_one in param.LIST" :value="list_one.ID">{{list_one.VALUE}}</option>
                                                            </select>

                                                    </div>

                                                    <textarea v-if="param.PROPERTY_TYPE == 'S' && param.ROW_COUNT !== '1'" id="" cols="30" rows="10" v-model="param.VALUE_USER" :placeholder="param.NAME"></textarea>

                                                    <!-- <file-upload v-if="param.PROPERTY_TYPE == 'F'" :url='url'  :accept="param.FILE_TYPE" ></file-upload> -->
                                                    <!-- <input :ref="param.CODE"  v-if="param.PROPERTY_TYPE == 'F'" type="file" v-on:change="uploadFiles"> -->
                                                    <div class="file-field" v-if="param.PROPERTY_TYPE == 'F'">

                                                        <div v-if="param.VALUE_USER" class="file">{{param.VALUE_USER[0].name}}</div>
                                                    </div>

                                                <div class="required" v-if="param.IS_REQUIRED == 'Y'">*</div>
                                                <div class="error-field">{{param.ERROR}}</div>
                                        </div>
                                   
                                </div>
                                <div class="col-md-12">
                                    <div class="politic" v-if="politic.param == 'Y'">
                                        <input type="checkbox" id="politic" name="politic" v-model="politic.politic_check">
                                        <label for="politic">Я соглашаюсь с <a style="font-weight: 600;" href="/polzovatelskoe-soglashenie">политикой конфиденциальности</a> </label>
                                        <div class="error-field">{{politic.text_error}}</div>
                                    </div>
                                    <input type="submit" class="btn-feed" value="Отправить" >
                                </div>
                            </div>
                        
                        <!-- <div class="status" v-show="responseOk">{{responseAjax}}</div> -->
                        <div class="success" v-show="responseOk">
                            Ваша заявка принята!
                        </div>
            </div>
        </div>
    </form>

</div>
</template>

<style>
    .form-content
    {
        width:100%;
        justify-content: space-between;
    }

    .one-group
    {
        width:48%;
    }

    textarea
    {
        border:1px solid #f0f0f0;
    }


</style>


<script>

import axios from 'axios';

//import catalog from '@/mixins/catalog';

export default {

                        //el:"#form_vue_<?=$arParams["ID_FORM"] ?>",
                        name: 'v-form',
                        props:["form-data"],
                        data: function (){

                                return {
                                    // signedParameters: '<?=$this->getComponent()->getSignedParameters() ?>',
                                    // formParams:'<?=json_encode($arResult["GROUPS"]) ?>',
                                    // token:'<?=bitrix_sessid(); ?>',
                                    politic: {'param':'Y', 'politic_check': false, 'text_error': ''},
                                    // responseAjax:"",
                                    formId:"feedback",
                                    dataBitrix:[],
                                    responseOk:false,
                                    url:"/bitrix/services/main/ajax.php",
                                    baseAjaxBitrix: new FormData(),
                                }
                        },
                        computed: {
                            


                        },
                        mounted: function () {

                            this.$set(this, "dataBitrix", JSON.parse(this.formData.formParams));
                            console.log(this.dataBitrix);
                            
                          
                        },
                        // components:{
                        //     "file-upload":FileUpload
                        // },
                        methods:{
                            // dataBitrix:function()
                            //     {
                            //         //console.log(JSON.parse(this.formParams));
                            //         return  JSON.parse(this.formParams);
                            //     },
                            uploadFiles:function(){

                                for(code in  this.$refs)
                                {
                                    //console.log(this.$refs[code]);
                                    //console.log(this.$refs[code][0].files[0]);
                                    this.baseAjaxBitrix.set("params["+code+"]", this.$refs[code][0].files[0].file);
                                   // console.log(this.$refs[code][0].files[0]);
                                   
                                }
                               

                            },
                            validate:function()
                            {
                                var error = false;
                                var vue = this;
                                var param, i = 0;
                                let group = 0;
                                //this.dataBitrix.forEach(function(param, i, arr){
                                    
                                for(group in this.dataBitrix)
                                {
                                    this.dataBitrix[group].PARAMS.forEach(function(param, i, arr){
                                        if(param.IS_REQUIRED == 'Y')
                                        {
                                            if(param.VALUE_USER == undefined && param.PROPERTY_TYPE !== 'F')
                                            {

                                                error = true;
                                                vue.$set(vue.dataBitrix[group].PARAMS[i], "ERROR", "Поле обязательно для заполнения");
                                                //this.dataBitrix = this.dataBitrix;
                                                //param.ERROR = "Поле обязательно для заполнения";
                                            }


                                        }

                                    });

                                }


                                if(!this.politic.politic_check)
                                {
                                    error = true;
                                    this.politic.text_error = 'Вы должны принять политику конфедициальности';
                                }

                               console.log(error);

                                if(error)
                                {
                                    return false;
                                }

                                return true;
                            },
                            sendForm: function(event)
                            {

                               
                                event.preventDefault();
                                event.stopImmediatePropagation();
                                //this.dataBitrix[0] = 
                                let group = 0;
                                var status = this.validate();
                                var vue_this = this;
                                 if(!status)
                                 {
                                    
                                     return false;
                                 }

                                 //console.log("Dsds");
                                 //return false;
                                //var dataSend = [];
                                var dataSend = {};
                                //console.log(this.dataBitrix);
                                //var baseAjaxBitrix = {};
                                var params_query = {c: 'vue:form',
                                                      action: 'sendForm',
                                                        mode: 'class',
                                                        SITE_ID: 's1',
                                                        sessid: this.formData.token,
                                                        
                                                        };
                                                        ///console.log(group);
                                

                                for(group in this.dataBitrix)
                                {
                                   // this.dataBitrix[group].PARAMS
                                   // console.log(this.dataBitrix[group].PARAMS);
                                  
                                    this.dataBitrix[group].PARAMS.forEach(function(param, i, arr){
                                    //dataSend[param.CODE] = param.VALUE_USER;
                                        if(param.PROPERTY_TYPE !== 'F')
                                        {
                                            console.log("add");
                                            vue_this.baseAjaxBitrix.set("params["+param.CODE+"]", param.VALUE_USER);
                                        }
                                    });
                                }
                                // this.dataBitrix.map(function(group){
                                  
                                // });
                                //console.log(baseAjaxBitrix);
                                //return false;
                                
                                this.baseAjaxBitrix.set("formId", this.formId);
                                this.baseAjaxBitrix.set("signedParameters", this.formData.signedParameters);
                                //dataSend["SITE_ID"] = 's1';
                               // dataSend["sessid"] = this.token;
                                //baseAjaxBitrix = {"params":dataSend};
                                //baseAjaxBitrix["data"] = dataSend;
                                
                               
                                let vue = this;

                               // this.baseAjaxBitrix.signedParameters = this.signedParameters;
                                //     console.log(this.baseAjaxBitrix);
                                // $.ajax({
                                //     type: "POST",
                                //     url: "/bitrix/services/main/ajax.php?"+params_query.toString(),
                                //     data: this.baseAjaxBitrix,
                                //     headers: {'x-bitrix-csrf-token': this.formData.token,
                                //              'x-bitrix-site-id': "s1" },
                                //     contentType: 'multipart/form-data',
                                //     //dataType: "dataType",
                                //     success: function (response) {

                                //         if (response.status === 'success') {

                                //             vue_this.responseOk = true;
                                //              vue_this.responseAjax = response;
                                //             //console.log(response.data.data);

                                //         }
                                //         //console.log(response);
                                //     }
                                // });
                                
                                axios
                                    .post('/bitrix/services/main/ajax.php', this.baseAjaxBitrix, {params: params_query, 
                                                                                                  headers: {
                                                                                                    'Content-Type': 'multipart/form-data'
                                                                                                 }
                                                                                            })
                                    .then(function (response) {
                                            // handle success
                                            vue_this.responseOk = true;
                                            vue_this.responseAjax = response;
                                        })
                                    .catch(error => console.log(error));
                                //console.log(this.responseAjax);
                                
                            }

                        }


}


</script>